export default {
    name: 'sps-redpipe',
    handle(state, to, from, next) {
        if (window.location.href.indexOf('redpipe.') === -1)
            return false;

        let regex = /[?&]redpipe\.([^=#]+)=([^&#]*)/g;
        let url = window.location.href;
        let params = [];
        let match;
        while (match = regex.exec(url)) {
            params.push({
                key: match[1],
                val: match[2]
            });
        }
        if (params.length) {
            state.redpipe.frameParameters.set(params);
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./skins/xkiosk/routehandlers/common/redpipe.routehandler.js